import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Careeredit = () => {
  const [formData, setFormData] = useState({
    role: "",
    vacancy: "",
    job_description: "",
  });
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchCareer();
  }, [id]);

  const fetchCareer = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        `https://ambatturindustrialestate.com/api/api/careers/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setFormData({
          role: data.role,
          vacancy: data.vacancy,
          job_description: data.job_description,
        });
      } else {
        setMessage("Failed to fetch career details.");
      }
    } catch (error) {
      console.error("Error fetching career:", error);
      setMessage("An error occurred while fetching the career posting.");
    } finally {
      setFetchLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("access");

      const response = await fetch(
        `https://ambatturindustrialestate.com/api/api/careers/${id}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setMessage("Career posting updated successfully!");
        setTimeout(() => {
          navigate("/careers");
        }, 1500);
      } else {
        const errorData = await response.json();
        setMessage(errorData.detail || "Failed to update career posting.");
      }
    } catch (error) {
      console.error("Error updating career:", error);
      setMessage("An error occurred while updating the career posting.");
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Edit Career Posting</h4>
            </div>
            <div className="card-body">
              {message && (
                <div
                  className={`alert ${
                    message.includes("successfully")
                      ? "alert-success"
                      : "alert-danger"
                  } alert-dismissible fade show`}
                >
                  {message}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setMessage("")}
                  ></button>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="role" className="form-label">
                    Role *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="vacancy" className="form-label">
                    Number of Vacancies *
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="vacancy"
                    name="vacancy"
                    min="1"
                    value={formData.vacancy}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="job_description" className="form-label">
                    Job Description *
                  </label>
                  <textarea
                    className="form-control"
                    id="job_description"
                    name="job_description"
                    rows="8"
                    value={formData.job_description}
                    onChange={handleChange}
                    required
                    placeholder="Describe the job responsibilities, requirements, benefits, etc."
                  ></textarea>
                </div>

                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate("/careers")}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Career Posting"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careeredit;
